module.exports = __webpack_public_path__ + "img/04.33ab4380.jpg";